import { useHistory } from 'react-router-dom';
import { PiChartLineUpDuotone } from 'react-icons/pi';
import { FcTreeStructure } from 'react-icons/fc';

import Node, { NodeMessage, NodeValue, Button } from 'app/admin/optimizationPipelineV2/component/pipeline/nodes/base/Node';

import { useOptimizationPipeline } from 'app/admin/optimizationPipelineV2/component/pipeline/providers/OptimizationPipelineProvider';

function getAccurateMeta(accurate) {
    if (accurate === true) { return { value: 'Accurate', severity: 'success' }; }
    if (accurate === false) { return { value: 'Inaccurate', severity: 'error' }; }
    return { value: 'Missing', severity: 'warning' };
}

export default function ModelValidationNode(props) {
    const history = useHistory();
    const {
        ts,
        optimizationPipelineDetail,
        optimizationPipelineDetailsLoading,
        optimizationPipelineDetailsLoaded,
        openSidebar,
        openPopup,
        getOnDemandResource,
        ensureOnDemandResource
    } = useOptimizationPipeline();

    const accurate = optimizationPipelineDetail?.model_validation_is_accurate;
    const message = optimizationPipelineDetail?.model_validation_data?.message;

    const accurateMeta = getAccurateMeta(accurate);

    const modelValidationResource = getOnDemandResource('modelValidationData');
    const modelValidationData = modelValidationResource?.data;

    async function handleShow() {
        const data = modelValidationData || await ensureOnDemandResource('modelValidationData');

        if (!data?.whatIf || !data?.modelValidationLog || !ts) return;

        history.push('/what-if/edit/' + data.whatIf + '/M' + data.modelValidationLog + '&TS' + ts);
    }

    const showDisabled = !ts;

    return (
        <Node ref={props.anchorRef} title='Model Validation' icon={PiChartLineUpDuotone} fit={props.fit} loading={optimizationPipelineDetailsLoading || !optimizationPipelineDetailsLoaded}>

            <div className='w-full flex flex-col gap-8'>

                <NodeValue label='Accurate' value={accurateMeta.value} severity={accurateMeta.severity} />

                {message && <NodeMessage value={message} />}

                <div className='w-full flex flex-col gap-10'>

                    <div className='w-full flex gap-10'>
                        <Button genericType='DETAILS' onClick={() => { openSidebar({ type: 'MODEL_VALIDATION', query: '', relevantOnly: false, minWidth: 520, maxWidth: 1280, width: '70vw' }); }} />
                        <Button genericType='HISTORY' onClick={() => { openPopup({ type: 'MODEL_VALIDATION_HISTORY' }); }} />
                    </div>

                    <Button genericType='SHOW' onClick={handleShow} disabled={showDisabled} />

                </div>

            </div>

        </Node>
    );
}